import { render, staticRenderFns } from "./Parrain.vue?vue&type=template&id=17187f62&scoped=true"
import script from "./Parrain.vue?vue&type=script&lang=js"
export * from "./Parrain.vue?vue&type=script&lang=js"
import style0 from "./Parrain.vue?vue&type=style&index=0&id=17187f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17187f62",
  null
  
)

export default component.exports